import { capitalize } from 'lodash';

import { formatDate, iaRa } from 'lib/helpers/utility';

import SuperbillActions from 'components/practice/charts/billing/superbill/components/SuperbillActions';

import { filterSuperbillClaimProcedure } from '../../lib/procedureUtils';

export default function (timezone) {
  return [
    {
      field: 'id',
      headerName: 'Superbill ID',
      maxWidth: 140,
      headerCheckboxSelection: true,
      checkboxSelection: (params) => !params.node.group
    },
    {
      field: 'patient_name',
      headerName: 'Patient Name',
      valueFormatter: (params) => {
        if (params?.node?.group) return params?.node?.key;
        return (params?.data?.f_name || '') + ' ' + (params?.data?.l_name || '');
      },
      keyCreator: (params) => (params?.data?.f_name || '') + ' ' + (params?.data?.l_name || '')
    },
    {
      field: 'provider_name',
      headerName: 'Rend. Prov.',
      valueFormatter: ({ value }) => capitalize(value),
      flex: 1,
      minWidth: 170
    },
    {
      field: 'bill_name',
      headerName: 'Bill. Prov.',
      valueFormatter: ({ value }) => capitalize(value),
      minWidth: 170,
      flex: 1
    },
    {
      field: 'payer_name',
      headerName: 'Payer',
      valueFormatter: ({ value }) => capitalize(value),
      minWidth: 170,
      flex: 1
    },
    {
      field: 'starts_at',
      headerName: 'DOS',
      valueFormatter: ({ value }) => formatDate(value, timezone, true),
      width: 150
    },
    {
      field: 'services',
      headerName: 'Services',
      valueGetter: (params) => {
        const services = iaRa(params.data?.invoice_procedures)
          .filter(filterSuperbillClaimProcedure)
          .map((item) => item.procedure_code)
          ?.join(', ');

        return services || null;
      },
      sortable: false
    },
    {
      field: 'claim_id',
      headerName: 'Claim',
      valueFormatter: ({ value }) => capitalize(value),
      maxWidth: 150,
      minWidth: 120
    },
    {
      field: 'state',
      headerName: 'Status',
      valueFormatter: ({ value }) => capitalize(value),
      maxWidth: 100
    },
    { field: 'resource_name', headerName: 'Resource' },
    {
      field: 'actions',
      headerName: 'Actions',
      cellRenderer: SuperbillActions,
      maxWidth: 88,
      minWidth: 36,
      resizable: false,
      sortable: false,
      pinned: 'right'
    }
  ];
}

export const SUPERBILL_SWITCH_ITEMS = [
  {
    label: 'Draft',
    value: 'draft'
  },
  {
    label: 'Complete',
    value: 'complete'
  }
];
